import templateUrl from "emun.prospect/prospect-container.htm";
import basicController from "servicestack/basic.controller.properties";
import createTemplateUrl from "emun.prospect/prospect-create.htm";
import modals from "webmodals/modals";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
//import resolve from "ioc/resolve";
import prospectConfig from "emun.prospect/prospect.config";
import customerConfig from "emun.customer/customer.config";
import labels from "emun.prospect/_labels";

export const filters = prospectConfig.filters;

export class ProspectContainerController {
  constructor($rootScope, prospectPrompt) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.prompt = prospectPrompt;
    $ctrl.rootScope = $rootScope;
    $ctrl.prospectConfig = prospectConfig;
    $ctrl.customerConfig = customerConfig;
    const options = {
      url: "QueryProspects.json",
      take: 12,
      pageSize: 12,
      orderBy: "-Hot,-CreatedOn,CompanyName",
      autoLoad: true,
      hideLeftNav: true,
      // disableQueryString: false,
      append: false,
      criteria: {
        StatusIn: ["New", "Active"],
      },
      filters,
      sortOptions: {
        "-Hot,-CreatedOn,CompanyName": "Hot",
        Id: "Id: 1 to 9",
        "-Id": "Id: 9 to 1",
        CompanyName: "Name: A to Z",
        "-CompanyName": "Name: Z to A",
        City: "City: A to Z",
        "-City": "City: Z to A",
        State: "State: A to Z",
        "-State": "State: Z to A",
        Zip: "Zip: 1 to 9",
        "-Zip": "Zip: 9 to 1",
      },
      onLoaded: (args) => $rootScope.$broadcast("prospectSearchLoaded"),
    };
    $ctrl.query = new AutoQuery(options);

    $rootScope.$on("prospectSaved", () => $ctrl.refreshTotals());
    $rootScope.$on("prospectDeleted", () => $ctrl.refreshTotals());
  }

  refreshTotals() {
    let $rootScope = resolve("$rootScope");
    $rootScope.$broadcast("refreshProspects");
    //const $ctrl = this;
    //$ctrl.query.criteria.dateRange = $ctrl.dateRange.id;
    //$ctrl.query.criteria.source = $ctrl.source.id;
    //$ctrl.query.criteria.salesRepId = $ctrl.rep.id;
    //$ctrl.query.load(true);
    //$ctrl.totalQuery.criteria.dateRange = $ctrl.dateRange.id;
    //$ctrl.totalQuery.criteria.source = $ctrl.source.id;
    //$ctrl.totalQuery.criteria.salesRepId = $ctrl.rep.id;
    //$ctrl.totalQuery.load(true);
  }

  load() {
    const $ctrl = this;
    return $ctrl.query.load.apply($ctrl.query, arguments);
  }

  deleteProspect(prospect) {
    let $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete Prospect")
      .result.then(function () {
        $ctrl.bus.send("DeleteProspect", prospect);
        $ctrl.query.load(true);
      });
  }

  add() {
    const $ctrl = this;
    return modals
      .open({
        templateUrl: createTemplateUrl,
        controllerAs: "$ctrl",
        controller($rootScope, $uibModalInstance, $session, createServiceBus) {
          let $ctrl = this;
          $ctrl.prospectConfig = prospectConfig;
          $ctrl.labels = labels;
          basicController($ctrl);
          $ctrl.model = {
            status: "New",
            source: "Direct",
            salesRep: {
              id: $session.salesRepId,
            },
            tags: {},
            storeType: "",
            salesRepID: $session.salesRepId,
            country: "US",
            orderSource: "",
            accountType: "",
            category: "",
          };
          let bus = ($ctrl.bus = new ServiceBus());
          $ctrl.title = "Create Prospect...";

          $ctrl.save = function () {
            if ($ctrl.model.storeType) {
              $ctrl.model.storeType = $ctrl.model.storeType.join(",");
            }
            //$ctrl.model.storeType = $ctrl.model.storeType.replace("[", "").replace("]", "");
            $ctrl.bus
              .send("CreateProspect.json", $ctrl.model)
              .then(function (response) {
                $rootScope.$emit("prospectSaved", $ctrl);
                $ctrl.model.id = response.data.id;
                if ($ctrl.model.media) {
                  $ctrl.model.media.tags["ProspectId"] = $ctrl.model.id;
                  //$ctrl.model.media.tags = {
                  //    ProspectId: $ctrl.model.id
                  //};
                  $ctrl.bus.send("UpdateMedia", $ctrl.model.media);
                }
                $uibModalInstance.close($ctrl.model);
              });
          };
          $ctrl.dismiss = $ctrl.cancel = $uibModalInstance.dismiss;
          $ctrl.upload = function ($files) {
            if ($files && $files.length) {
              let req = {
                request: {
                  realm: "Prospect",
                  tags: {
                    ProspectId: $ctrl.model.id,
                  },
                },
                files: $files,
                urls: [],
              };

              $ctrl.bus
                .upload("CreateMedia.json", req)
                .then(function (response) {
                  $ctrl.model.media = response.data.media[0];
                });
            }
          };
          $ctrl.toggleHot = function () {
            $ctrl.model.hot
              ? ($ctrl.model.hot = false)
              : ($ctrl.model.hot = true);
          };
        },
        size: "md",
      })
      .result.then(function () {
        $ctrl.query.load();
      });
  }

  setStatus(prospect, status) {
    const $ctrl = this;
    prospect.status = status;
    $ctrl.bus.send("UpdateProspect.json", prospect).then(function (response) {
      $ctrl.refreshTotals();
    });
  }

  toggleHot(prospect) {
    const $ctrl = this;
    prospect.hot ? (prospect.hot = false) : (prospect.hot = true);
    $ctrl.bus
      .send("UpdateProspect.json", prospect)
      .then(function (response) {});
  }
  openMap(prospect) {
    prospect.location =
      prospect.address +
      " " +
      prospect.city +
      ", " +
      prospect.state +
      " " +
      prospect.zip;
    window.open("http://www.google.com/maps/place/" + prospect.location);
  }
}

export default {
  controller: ProspectContainerController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
